module.exports = __webpack_public_path__ + "f19979464b1fc7004ffa01735ca51b3c.svg";